import { RoleCode, type RoleCodeValue } from '../../utils/role-access';

/** Exact role → dashboard template variant (widgets + copy). */
export type DashboardLayout =
  | 'SYSTEM_ADMIN'
  | 'SYSTEM_FINANCIAL'
  | 'SYSTEM_DEVELOPER'
  | 'MERCHANT_ADMIN'
  | 'MERCHANT_FINANCIAL'
  | 'MERCHANT_DEVELOPER';

export function dashboardLayoutForRole(role: RoleCodeValue | null): DashboardLayout {
  switch (role) {
    case RoleCode.SYSTEM_ADMIN:
      return 'SYSTEM_ADMIN';
    case RoleCode.SYSTEM_FINANCIAL:
      return 'SYSTEM_FINANCIAL';
    case RoleCode.SYSTEM_DEVELOPER:
      return 'SYSTEM_DEVELOPER';
    case RoleCode.MERCHANT_ADMIN:
      return 'MERCHANT_ADMIN';
    case RoleCode.MERCHANT_FINANCIAL:
      return 'MERCHANT_FINANCIAL';
    case RoleCode.MERCHANT_DEVELOPER:
      return 'MERCHANT_DEVELOPER';
    default:
      return 'SYSTEM_ADMIN';
  }
}

/** Which summary / BI blocks to show per layout. */
export interface DashboardSectionFlags {
  showUserSummary: boolean;
  showMerchantSummary: boolean;
  showApplicationsSummary: boolean;
  showWalletsSummary: boolean;
  showEntitiesSummary: boolean;
  showTransactionMetrics: boolean;
  showTransactionHealth: boolean;
  showCharts: boolean;
  showWalletBalancesPanel: boolean;
  showTransactionTypesPanel: boolean;
  showRecentActivity: boolean;
}

export function sectionFlagsForLayout(layout: DashboardLayout): DashboardSectionFlags {
  const mf = layout === 'MERCHANT_FINANCIAL';
  return {
    showUserSummary: layout === 'SYSTEM_ADMIN',
    showMerchantSummary: true,
    showApplicationsSummary: !mf,
    showWalletsSummary: true,
    showEntitiesSummary:
      layout === 'SYSTEM_ADMIN' || layout === 'SYSTEM_FINANCIAL' || layout === 'SYSTEM_DEVELOPER',
    showTransactionMetrics: true,
    showTransactionHealth: !mf,
    showCharts: !mf,
    showWalletBalancesPanel: true,
    showTransactionTypesPanel: !mf,
    showRecentActivity: !mf,
  };
}
